import { brand } from '../../tokens';

// Clerk's forms and its account modal in ADAS's look (wf-auth 1–4, YES-212). AuthCard draws the
// card and the heading, so Clerk's own card is flat and its header hidden there.
export const clerkAppearance = {
    variables: {
        colorPrimary: brand.accent,
        colorText: brand.ink,
        colorTextSecondary: brand.inkMuted,
        colorBackground: brand.paper,
        colorInputBackground: brand.paper,
        colorInputText: brand.ink,
        colorDanger: '#B42318',
        fontFamily: brand.body,
        fontFamilyButtons: brand.body,
        fontSize: '0.9375rem',
        borderRadius: '8px',
    },
    elements: {
        formButtonPrimary: {
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            transition: 'background-color 150ms',
            '&:hover': { backgroundColor: brand.accentHover },
        },
        formFieldInput: {
            borderColor: brand.lineStrong,
        },
        headerTitle: {
            fontFamily: brand.display,
            fontWeight: 700,
        },
    },
};

// Inside AuthCard: no card of Clerk's own, no Clerk header, a plain footer line
export const embeddedAppearance = {
    elements: {
        rootBox: { width: '100%' },
        cardBox: { width: '100%', boxShadow: 'none', border: 'none', borderRadius: 0 },
        card: { padding: 0, boxShadow: 'none', border: 'none', backgroundColor: 'transparent' },
        header: { display: 'none' },
        footer: { background: 'transparent', padding: 0, marginTop: '16px', borderTop: `1px solid ${brand.lineStrong}` },
        footerAction: { padding: '16px 0 0', justifyContent: 'flex-start' },
        footerActionLink: { color: brand.accent, fontWeight: 600 },
    },
};

// The wireframes' wording for the parts of Clerk's forms ADAS keeps
export const clerkLocalization = {
    formFieldAction__forgotPassword: 'Forgot password?',
    formButtonPrimary: 'Continue',
    signIn: {
        start: {
            actionText: 'New to ADAS?',
            actionLink: 'Create a teacher account',
        },
    },
    signUp: {
        start: {
            actionText: 'Already have an account?',
            actionLink: 'Sign in',
        },
        emailCode: {
            resendButton: 'Didn’t get it? Send again',
        },
    },
};
